import React from 'react';
import { Flex, Typography } from 'antd';

const { Title, Text } = Typography;

const EmptyState = ({ message, description, icon }) => (
    <Flex vertical align="center" justify="center" style={{ padding: '60px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px', opacity: 0.5 }}>
            {icon || '📦'}
        </div>
        <Title level={5} style={{ margin: 0, fontWeight: 600, color: '#434343' }}>
            {message}
        </Title>
        <Text type="secondary" style={{ fontSize: '13px', maxWidth: '300px', marginTop: '4px' }}>
            {description}
        </Text>
    </Flex>
);

export default EmptyState;
